import "client-only";

import { createBrowserClient } from "@supabase/ssr";

import { Database } from "./database.types";

export function createSupabaseClientForBrowser() {
  // fyi: createBrowserClient uses a singleton pattern
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        storageKey: process.env.NEXT_PUBLIC_SB_STORAGE_KEY,
      },
    },
  );
}
